import { handleError } from 'common/utils/app.utils';
import React, { MouseEventHandler, useState } from 'react';
import { EDIT_CART_ACTION, getBulkEditRequest } from '../configure-plan-pricing-constant';
import { doBulkEditAction } from '../configure-plan-pricing.service';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './contract-period.scss';
import { isNLD_OR_LL } from 'common/constants/app.constants';
import { getTotalLinks } from './formControl.service';

type Props = {
  hidePopup: MouseEventHandler;
  records: Array<any>;
  reFetchRecords: Function;
};

export const DeleteSites = ({ hidePopup, records, reFetchRecords }: Props) => {
  const [loader, setLoader] = useState<boolean>(false);
  const deleteHandler = () => {
    setLoader(true);
    const requestParam = getBulkEditRequest(EDIT_CART_ACTION.DELETE_SITE, records);
    doBulkEditAction(requestParam).then(
      (response: any) => {
        setLoader(false);
        reFetchRecords?.();
        hidePopup?.(false as any);
      },
      (err: any) => {
        setLoader(false);
        handleError(err);
      }
    );
  };

  const getMessage = () => {
    if (isNLD_OR_LL()) {
      return (
        <p className="contract-message">
          <span>{getTotalLinks(records)} selected links</span> will be deleted from the system. Please note that both the sites(Point A and Point B) of a link will be automatically
          deleted. Are you sure you want to proceed?
        </p>
      );
    }
    return (
      <p className="contract-message">
        <span>{getTotalLinks(records)} selected links</span> will be deleted from the system. Please note that deleting the primary link of dual last mile will auto-delete the
        secondary link. Are you sure you want to proceed?
      </p>
    );
  };

  return (
    <div className="drawerSection">
      <div className="popup-section cancelOrder contractPeriod">
        <h2 className="cancel-head">Delete Sites</h2>
        {getMessage()}
        <div className="characters">&nbsp;</div>
        <div className="buttonSection">
          <Button type="button" variant="outlinebtn" onClick={hidePopup}>
            Cancel
          </Button>
          <Button type="button" disabled={loader} onClick={deleteHandler}>
            Delete
            {loader && <span className="loading_icon"></span>}
          </Button>
        </div>
      </div>
    </div>
  );
};
